var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.keepAlive,"max":10}},[_c('router-view')],1),_c('loading',{attrs:{"show":_vm.isLoading,"text":_vm.loadingTxt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }